export class Constants {
  public static stsAuthority = process.env.REACT_APP_BASE_STSAUTHORITY;
  public static clientId = process.env.REACT_APP_BASE_WSO2_CLIENT_ID;
  public static clientRoot = `${window.location.origin}`;
  public static clientScope = process.env.REACT_APP_BASE_CLIENTSCOPE;
  public static apiRoot = process.env.REACT_APP_BASE_APIROOT;
  public static redirect_uri = `${window.location.origin}/signin-oidc/`;
  public static silent_redirect_uri = `${window.location.origin}/silentrenew`;
  public static post_logout_redirect_uri = `${window.location.origin}/logout-callback`;
  public static response_type = process.env.REACT_APP_BASE_RESPONSE_TYPE;
  public static clientKey = process.env.REACT_APP_BASE_WSO2_CLIENT_ID;
  public static appConfigLabel =
    process.env.REACT_APP_AZURE_APP_CONFIG_ENVIRONMENT_LABEL;
  public static appDefaultTenantAlias =
    process.env.REACT_APP_DEFAULT_TENANT_ALIAS;
}
